













































































































import { Vue, Component } from "vue-property-decorator";
import TestPassV2 from "@/components/tests/TestPassV2.vue";
import api from "@/getinfo-api";
import { Course as ICourse } from "@/api/models/course";
import { CourseLecture as ICourseLecture } from "@/api/models/course-lecture";
import { Test as ITest } from "@/api/models/test";
import { AxiosError } from "axios";
import { ErrorResponse } from "@/api/models/error-response";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { User as IUser } from "@/api/models/user";
import TextField from "@/components/form/CustomPage/textField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";

@Component({
  components: { CBlock, TextField, TestPassV2 }
})
export default class TestView extends Vue {
  courseInfo!: ICourse;
  courseLectureInfo?: ICourseLecture;
  userAccessToEditCourse: boolean = false;
  testInfo!: ITest;
  owner!: IUser;
  action!: boolean;

  data() {
    return {
      courseInfo: undefined,
      courseLectureInfo: undefined,
      testInfo: undefined,
      owner: undefined,
      action: undefined
    };
  }

  submitChange() {
    this.action = false;
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get canEdit() {
    return (this.userAccessToEditCourse =
      this.root || this.companyOwner || this.testInfo.ownerId === this.userId);
  }

  get materialLink() {
    return this.courseLectureInfo
      ? {
          name: "lectureView",
          params: {
            courseId: this.$route.params.courseId,
            courseLectureId: this.courseLectureInfo.id
          }
        }
      : {
          name: "courseView",
          params: {
            courseId: this.courseInfo.id
          }
        };
  }

  get timeToTest() {
    return this.testInfo && this.testInfo.timeLimit !== 0
      ? `${this.testInfo.timeLimit} `
      : this.$tc(this.$translate.NotLimited);
  }

  get countPerDay() {
    return this.testInfo && this.testInfo.attemptsCountPerDay !== 0
      ? this.testInfo.attemptsCountPerDay
      : this.$tc(this.$translate.NotLimited);
  }

  get materialTitle() {
    return this.courseLectureInfo
      ? this.courseLectureInfo.lecture.title
      : this.courseInfo.title;
  }

  get allTestCount() {
    return this.testInfo.attemptsCount
      ? this.testInfo.attemptsCount
      : this.$tc(this.$translate.NotLimited);
  }

  get questionsCountToCompletion() {
    return this.testInfo.questionsCountToCompletion
      ? this.testInfo.questionsCountToCompletion
      : this.$tc(this.$translate.NotLimited);
  }

  getOwner() {
    api.UsersApi.get(this.testInfo.ownerId).then((res: { data: IUser }) => {
      this.owner = res.data;
    });
  }

  mounted() {
    if (this.$route.params.courseLectureId) {
      api.CourseLectureApi.get(
        this.$route.params.courseId,
        this.$route.params.courseLectureId
      ).then((res: { data: ICourseLecture }) => {
        this.courseLectureInfo = res.data;
        document.title += ` ${res.data.lecture.title}`;
        if (res.data.test) {
          this.testInfo = res.data.test;
        }
      });
    } else {
      api.CourseApi.get(this.$route.params.courseId)
        .then((res: { data: ICourse }) => {
          this.courseInfo = res.data;
          document.title += ` ${this.courseInfo.title}`;

          if (res.data.test) {
            this.testInfo = res.data.test;
            this.getOwner();
          }
        })
        .catch((error: AxiosError<ErrorResponse>) => {
          if (error.response) {
            this.$bvToast.toast(error.response.data.message, {
              variant: "danger",
              title: "Error"
            });
          }
        });
    }
  }
}
